import { create } from "apisauce";
import { initializeApp, getApps, getApp} from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import firebaseConfig from "@serie3/mymediaplanner/Config/Firebase/firebase";
import getSettings from "../config/settings";
import ToastMessages from "../../web/src/ToastMessages";

const settings = getSettings();


export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);

const apiClient = create({
  baseURL: settings.apiUrl,
});

const baseURL = apiClient.getBaseURL();


apiClient.addAsyncRequestTransform(async (request) => {
  // Pull fresh token from Firebase; SDK refreshes if needed.
  const user = auth.currentUser;

  let idToken = null;
  let uid = null;

  if (user) {
    try {
      idToken = await user.getIdToken(); // no force; use cached/auto-refreshed
      uid = user.uid;
    } catch (e) {
      // If this fails, request goes unauthenticated; backend should return 401/403
    }
  } else {
    // Legacy fallback (not recommended): read what your app stored previously
    try {
      idToken = JSON.parse(localStorage.getItem("token") || "null");
      uid = JSON.parse(localStorage.getItem("localId") || "null");
    } catch {}
  }

  if (!idToken) return;

  // Keep your existing headers
  request.headers["x-auth-token"] = idToken;
  request.headers["x-auth-id"] = uid || "";

  // Also add a standard Bearer header (useful if you add middleware later)
  request.headers["Authorization"] = `Bearer ${idToken}`;
});

// Demo mode: treat every response as successful so the UI works without a real backend.
apiClient.addResponseTransform((response) => {
  try {
    const roles = JSON.parse(localStorage.getItem("roles") ?? "[]");
    if (Array.isArray(roles) && roles.includes("ROLE_DEMO_USER") && !response.ok) {
      response.ok = true;
      response.status = 200;
      if (response.data == null) response.data = {};
      return;
    }
  } catch { /* ignore */ }
});

apiClient.addResponseTransform((response) => {
  switch (response.status) {
    case 500:
      ToastMessages.Error();
      break;
    case 403:
      if (window.location.hostname === "stage.mynomadplace.com") {
        window.location.replace("/datareset");
      }
      break;
    case 422:
      signOut(auth);
      window.location.replace("/notverified");
      break;
    case 404:
      ToastMessages.NotFound();
      break;
    case 413:
      ToastMessages.Error("The file is too large for the server to accept.");
      break;
    case 402:
      window.location.replace("/plans");
      break;
  }
});

export default apiClient;
